import React, { useState, useCallback } from "react";
import { Button } from "reactstrap";
import StatusFooter, { StatusProps } from "./StatusFooter";
import { EventProps, getMusicServiceName } from "./EventModel";
import { Link } from "react-router-dom";
import ActionsWrapper from "./ActionsWrapper";
import { EditEventStep } from "./EditEvent";
import { fetchData } from "./useAPI";

const StartEvent: React.FC<EventProps> = (props) => {
  const [status, setStatus] = useState<StatusProps>({
    status: "",
    error: undefined,
  });

  const startEvent = useCallback(async (): Promise<void> => {
    setStatus({ status: "Starting event..." });
    return fetchData(
      `api/events/${props.event.id}/start`,
      { method: "PUT" },
      () => setStatus({ status: "Event started" }),
      (err) => setStatus({ status: "", error: err as Error })
    );
  }, [props.event.id]);

  return (
    <div className="text-center">
      <p className="alert-header">Ready to Start Your Event?</p>
      <p className="alert-body-copy-bold">
        Before you do, check your guests have completed their song selections as
        no additions or changes will be allowed once you continue to the event
        music.
      </p>
      <ActionsWrapper>
        <Button
          color="secondary"
          tag={Link}
          to={`/edit/${props.event.id}/${EditEventStep.EditSongs}`}
        >
          Check Playlist Contributions
        </Button>
      </ActionsWrapper>
      <p className="alert-body-copy-bold mt-4">
        Continue to Event Music to access the event playlists in&nbsp;
        {getMusicServiceName(props.event.musicService)}.
      </p>
      <ActionsWrapper>
        <Button
          color="primary"
          onClick={startEvent}
          disabled={props.event.totalSelections === 0}
        >
          Continue to Event Music
        </Button>
        <Button
          className="btn-variant btn-tertiary"
          tag={Link}
          to={`/edit/${props.event.id}/${EditEventStep.Event}`}
        >
          Return to Event
        </Button>
      </ActionsWrapper>
      {props.children}
      <StatusFooter status={status.status} error={status.error} />
    </div>
  );
};

export default StartEvent;
